import { render, staticRenderFns } from "./toiletCom.vue?vue&type=template&id=2e622954&scoped=true"
import script from "./toiletCom.vue?vue&type=script&lang=js"
export * from "./toiletCom.vue?vue&type=script&lang=js"
import style0 from "./toiletCom.vue?vue&type=style&index=0&id=2e622954&prod&scoped=true&lang=scss"
import style1 from "./toiletCom.vue?vue&type=style&index=1&id=2e622954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e622954",
  null
  
)

export default component.exports